export const formatCategoryString = (str) => {
  const parts = str.split("/").filter(Boolean);

  const formattedParts = parts.map((part) =>
    part
      .split("-")
      .map((subPart) => subPart.charAt(0).toUpperCase() + subPart.slice(1))
      .join(" ")
  );

  return formattedParts.join(" - ");
};

export const normalizeString = (str) => {
  return str
    .replace(/[-\/]+/g, " ")
    .replace(/[^a-zA-Z0-9 _]+/g, "")
    .toLowerCase();
};
